export const walletsSorts = [
  { id: 1, prop: "holder", label: "WALLET.HOLDER_ID" },
  { id: 2, prop: "created_at", label: "SORT.CREATED_AT" },
];

export const walletsInitialFilter = {
  search: "",
  holder_id: {},
};
